import { Component, Input, OnInit } from '@angular/core';
import { EarnPointsModel, EarnPointsQuery, EarnPointsService, MemberQuery } from '@fgb/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'fgbcl-earn-points',
  templateUrl: './earn-points.component.html',
  styleUrls: ['./earn-points.component.scss'],
})
export class EarnPointsComponent implements OnInit {
  @Input() lgWidth: number = 6;

  constructor(
    private earnPointsQuery: EarnPointsQuery,
    private earnPointsService: EarnPointsService,
    private memberQuery: MemberQuery
  ) {}

  earnPoints$: Observable<EarnPointsModel[]>;

  ngOnInit() {
    const userContext = this.memberQuery.getUserContext();
    this.earnPointsService.fetchEarnPoints(+userContext.populationId, +userContext.lcid, userContext.clubId).subscribe();
    this.earnPoints$ = this.earnPointsQuery.selectAll();
  }
}
